export default {
  name: 'ko',
  data: {
    modal: {
      cancel: '취소',
      confirm: '확인'
    },
    pagination: {
      prev: '이전',
      next: '다음'
    },
    select: {
      empty: '데이터 없음... \\[ o_x ]/'
    },
    table: {
      empty: '데이터 없음... \\[ o_x ]/'
    }
  }
}